// next-app/src/app/(protected)/layout.tsx
'use client';

import { useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useAuthStore } from '@/store/auth-store';
import { MainNav } from '@/components/nav/main-nav';
import { MobileNav } from '@/components/nav/mobile-nav';
import { PublicFooter } from '@/components/nav/public-footer';

export default function ProtectedLayout({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const { dealer, isHydrated } = useAuthStore();

  useEffect(() => {
    // Wait for store hydration before checking auth
    if (isHydrated && !dealer) {
      // Store the intended destination for redirect after login
      const returnUrl = encodeURIComponent(pathname);
      router.replace(`/login?returnUrl=${returnUrl}`);
    }
  }, [dealer, isHydrated, pathname, router]);

  // Show nothing while checking auth or redirecting
  if (!isHydrated || !dealer) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-pulse text-gray-500">Loading...</div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      {/* Desktop Navigation - hidden on mobile */}
      <div className="hidden md:block">
        <MainNav />
      </div>

      {/* Mobile Navigation - hidden on desktop */}
      <div className="md:hidden">
        <MobileNav />
      </div>

      {/* Page Content */}
      <main className="flex-1 p-4 md:p-6">{children}</main>

      {/* Footer */}
      <PublicFooter />
    </div>
  );
}
